const colorList = [
  '#2684FC',
  '#FDE383',
  '#63DE77',
  '#F97316',
  '#51C0FF',
  '#ED4E5D',
  '#FF649C',
  '#23E8D3',
  '#2684FC',
  '#FDE383',
  '#F97316',
  '#51C0FF',
  '#ED4E5D',
  '#63DE77',
  '#FF649C',
  '#23E8D3',
  '#2684FC',
  '#FDE383',
  '#63DE77',
  '#F97316',
  '#51C0FF',
  '#ED4E5D',
  '#FF649C',
  '#23E8D3',
  '#2684FC',
  '#FDE383',
  '#F97316',
  '#51C0FF',
  '#ED4E5D',
  '#63DE77',
  '#FF649C',
  '#23E8D3',
]

export { colorList };